<div class="provisioning-container">
  <div class="provisioning-card">
    <div class="provisioning-header">
      <img src="assets/images/zeymo-logo.svg" alt="Zeymo" class="logo" />
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="loading">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>

    <!-- Error -->
    <div *ngIf="error" class="error-state">
      <h2>Something went wrong</h2>
      <p>{{ error }}</p>
    </div>

    <!-- Provisioning in progress -->
    <div *ngIf="status && !isCompleted && !isFailed && !isLoading">
      <h2>Setting up your account</h2>
      <p class="subtitle">This usually takes a few minutes. You can keep this page open.</p>

      <div class="progress-bar-wrapper">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="status.progress"></div>
        </div>
        <span class="progress-text">{{ status.progress }}%</span>
      </div>

      <div class="steps-list">
        <div *ngFor="let step of steps" class="step" [class]="getStepStatus(step)">
          <div class="step-icon">
            <span *ngIf="getStepStatus(step) === 'completed'" class="check">&#10003;</span>
            <span *ngIf="getStepStatus(step) === 'active'" class="spinner-small"></span>
            <span *ngIf="getStepStatus(step) === 'pending'" class="dot"></span>
          </div>
          <span class="step-label">{{ step.label }}</span>
        </div>
      </div>

      <p class="current-step" *ngIf="status.currentStep">{{ status.currentStep }}</p>
    </div>

    <!-- Completed -->
    <div *ngIf="isCompleted" class="completed-state">
      <div class="success-icon">&#10003;</div>
      <h2>Your account is ready!</h2>
      <p>Your workspace <strong>{{ status?.plannedTenantId }}</strong> has been set up successfully.</p>
      <p>Check your email for your login credentials.</p>
      <button class="login-btn" (click)="onLogin()">Go to Login</button>
    </div>

    <!-- Failed -->
    <div *ngIf="isFailed" class="failed-state">
      <div class="error-icon">!</div>
      <h2>Setup failed</h2>
      <p>{{ status?.errorMessage || 'Something went wrong during setup.' }}</p>
      <p>Please contact <a href="mailto:support@zeymo.com">support&#64;zeymo.com</a> for assistance.</p>
    </div>
  </div>
</div>
